import React from 'react';
import { Route } from 'react-router-dom';

import PoweredBy from 'components/PoweredBy';

export function PublicRoute({ children = null, ...routeConfig }) {
  return (
    <Route {...routeConfig}>
      {children}
      <PoweredBy className="mt-auto" />
    </Route>
  );
}
